/**
 * A fresh session, as a path this origin can serve.
 *
 * The API builds scanUrl from its own WEB_BASE_URL, which points at
 * production. Kept whole it would send a coach on the preview — or a
 * developer on localhost — to a different deployment than the one they are
 * looking at, so only the path and its code survive.
 */
export const sessionPath = (profileID: string, session: { ID?: string; scanUrl?: string | null }): string => {
  if (!session.ID) throw new Error('The scan session was not created.');
  if (!session.scanUrl) return `/scan/${profileID}/${session.ID}`;
  const url = new URL(session.scanUrl);
  return `${url.pathname}${url.search}`;
};
